import { type JSX, type Ref, forwardRef, createElement } from 'react';
import classNames from 'classnames';

const Card = forwardRef(
  ({ className, children, ...props }: JSX.IntrinsicElements['div'], ref: Ref<HTMLDivElement>) =>
    createElement(
      'div',
      {
        ...props,
        ref,
        className: classNames('rounded-md border border-cf-gray-4', className),
      },
      children,
    ),
);

export default Card;
